export default {
  analysisPlatform: {
    export: '导出',
    title: '绩效分析台',
    performanceDetails: '绩效明细',
    purchaseUnitNo: '采购中心',
    itemType: '物料类别',
    itemName: '物料名称',
    rank: '排名',
    nothing: '无',
    dataRange: '时间区间',
    examineYear: '考核年度',
    examineQuarter: '考核季度',
    examineMonth: '考核月份',
    performanceRanking: '绩效排名',
    publish: '发荣耀榜',
    performanceComparison: '绩效对比',
    performanceRating: '绩效评分',
    ranking: '排名',
    scoringTime: '评分时间',
    rater: '评分人',
    upgrade: '升级',
    rectification: '整改',
    frozen: '冻结',
    eliminate: '淘汰',
    totalScore: '总得分',
    grade: '等级',
    supplierType: '供应商类别',
    cooperativeProcurementCenter: '合作采购中心',
    contact: '联系人',
    compare: '绩效对比',
    compareInfo: '绩效对比详情',
    supplierCompare: '供应商绩效对比',
    supplier: '供应商',
    addSupplier: '添加供应商',
    selectGoodsDialog: {
      supplierNo: '供应商编码',
      supplierName: '供应商名称',
      classifyName: '供应商类别',
      supplierGroupName: '供应商组',
      statusName: '供应商状态',
      city: '城市',
      supScore: '最新评分',
      reviewTime: '最新评分时间'
    },
    purchaseUnitName: '采购中心',
    rateInfo: '评分详情',
    listMode: '列表模式',
    cardList: '卡片模式',
    publishSure: '确认发布',
    replaceBackground: '替换背景',
    updata: '升级',
    categoriesList: '查看全部类别排名',
    typeRanking: '类别排名',
    itemRanking: '物料名称排名',
    dialogTitle: '全部类别排名',
    sureOrNot: '是否确定',
    sureToExport: '是否确定导出',
    additem: '添加对象',
    title1: '当前绩效能力',
    title2: '绩效历史趋势',
    score: '总分',
    level: '当前等级',
    supBatLevel: '供应商按量/按批等级',
    topCount: '最优指标',
    highScore: '历史最高得分',
    rankDown: '较上次下降排名',
    rankUp: '较上次上升排名',
    higherThan: '高于',
    peers: '的同行',
    scoreRange: '分值处于',
    to: '至',
    tip1: '建议',
    tip2: '分值出于内，建议',
    tip3: '周期绩效考核荣耀榜',
    all: '全部',
    performanceExport: '绩效导出',
    selectDays: {
      90: '近三个月',
      180: '近半年',
      365: '近一年',
      0: '近三年'
    },
    watchRank: '查看排名',
    deadline: '最后评分时间',
    supplierColon: '供应商 :',
    purchaseUnitNoColon: '采购中心 :',
    noSupplier: '暂无可排名供应商',
    placeholder: '采购中心/工厂/物料'
  },
  assessmentIndicators: {
    searchPlaceholder: '考核编码/考核指标',
    quotaNo: '考核指标编码',
    quotaName: '考核指标名称',
    quotaTypes: '取值类型',
    purchaseUnitNos: '采购中心',
    quotaAttributes: '属性',
    quotaDetails: '指标细则',
    quotaOrigins: '来源',
    table: {
      quotaNo: '考核指标编码',
      quotaName: '考核指标名称',
      quotaType: '取值类型',
      purchaseUnitName: '采购中心',
      quotaAttribute: '属性',
      quotaDetail: '指标细则',
      quotaOrigin: '来源'
    },
    manualAccess: '手动获取',
    downloadTemplate: '模板下载',
    import: '导入',
    importTip: '仅允许上传"xls"或"xlsx"格式文件',
    add: '新增',
    modify: '编辑',
    del: '删除',
    addAssessmentIndicators: '考核指标新增',
    modifyAssessmentIndicators: '考核指标编辑',
    confirmTips: '是否删除该指标？',
    assessmentTemplate: '考核指标模板'
  },
  evaluationSystem: {
    examinePersonEd: '审核人',
    remove: '删除',
    max: '无穷大',
    min: '无穷小',
    search: {
      searchPlaceholder: '评估体系编码/评估体系名称',
      assessSystemName: '评估体系名称',
      addByName: '创建人',
      purchaseUnitNos: '采购中心',
      judgeNos: '物料类别',
      supplierNos: '供应商名称',
      statusList: '状态'
    },
    assessSystemNo: '评估体系编码',
    assessSystemName: '评估体系名称',
    addby: '创建人',
    adddate: '创建时间',
    usingFlag: '使用状态',
    import: '导入',
    importTip: '仅允许上传"xls"或"xlsx"格式文件',
    add: '新增',
    addEvaluationSystem: '评估体系新增',
    modifyEvaluationSystem: '评估体系编辑',
    modifyEvaluationCopy: '评估体系复制',
    del: '删除',
    modify: '编辑',
    manualExecute: '手动执行',
    use: '启用',
    startIt: '是否启用？',
    stop: '停用',
    stopIt: '是否停用？',
    copy: '复制',
    confirmCopy: '是否确认复制这一条数据',
    purchaseUnit: '采购中心',
    addPurchaseUnit: '添加采购中心',
    groupNo: '物料类别',
    supplierName: '供应商名称',
    status: '状态',
    effectDate: '生效日期',
    effectFailDate: '失效日期',
    baseInfo: '基础信息',
    evaluationSystem: '评估体系',
    addEvaluationLabel: '添加评估体系页签',
    addEvaluationTitle: '添加评估页签',
    removeTab: '是否删除该页签',
    tabName: '页签名称',
    weight: '权重（%）',
    elementWeight: '权重',
    maxPoints: '分数上限',
    minPoints: '分数下限',
    limitPoints: '分数上下限',
    addIndicator: '添加指标',
    workingStrategy: '运行策略',
    workingPeriod: '运行周期',
    workingDate: '运行时间',
    quotaNo: '考核指标编码',
    quotaName: '考核指标名称',
    quotaType: '取值类型',
    examinePerson: '考核人员',
    addTabTip: ['若不填写权重，请先清除其它页签的权重!', '权重大小需在1~100之间!', '所有页签的权重之和不能大于100%!', '若填写权重，请先完善其它页签的权重!'],
    formErrorMsg: ['请添加评估体系页签', '页签权重之和不等于100%', '请添加考核结果',
      '请在使用规则中添加物料类别', '请在使用规则中添加物料', '请在使用规则中添加考核对象',
      '请先添加采购中心', '失效日期不能小于生效日期', '评估体系页签中的权重只能全部填写或全部不填写'],
    addOneRow: '添加一行',
    examineRule: '考核规则',
    examineResult: '考核结果',
    examineResultScore: '分数制',
    examineResultRank: '排名制',
    scoreRegion: '分数区间',
    rankRegion: '排名区间',
    examineLevel: '考核等级',
    levelRemarks: '等级说明',
    isPass: '是否合格',
    performanceStrategy: '绩效策略',
    setStart: '设为启用',
    startTips: ['是否停用分数制启用排名制', '是否停用排名制启用分数制'],
    confirmTitle: '提示',
    confirmText: ['是', '否'],
    useRule: '使用规则',
    useRuleObj: {
      evaluationDimension: '评估维度',
      materialCategory: '物料类别',
      material: '物料',
      useMaterialCategory: '按物料类别',
      useMaterial: '按物料',
      none: '无',
      addMaterialCategory: '添加物料类别',
      addMaterial: '添加物料',
      examObject: '考核对象',
      addObject: '添加对象'
    },
    materialTable: {
      itemName: '物料名称',
      itemNo: '物料编码',
      itemSpec: '规格',
      groupName: '物料类别名称',
      groupNo: '物料类别编码',
      remarks: '备注'
    },
    supplier: '供应商',
    supplierTable: {
      placeholder: '供应商编码/供应商名称',
      supplierNo: '供应商编码',
      supplierName: '供应商名称',
      supplierType: '供应商类别',
      supplierGroup: '供应商组',
      supplierStatus: '供应商状态',
      city: '城市',
      action: '操作'
    },
    evaluationTemplate: '评估体系模板',
    tips1: '即将推出。。。',
    tips2: '请选择采购中心',
    bookmark: '页签',
    addTarget: '请添加指标',
    the: '第',
    row: '行',
    tips3: '请输入权重',
    tips4: '请输入分数上限',
    tips5: '请输入下限',
    tips6: '分数上限应大于分数下限',
    tips7: '请选择考核人员',
    tips8: '请输入分数区间从',
    tips9: '请输入分数区间止',
    tips10: '请分数区间从应小于分数区间止',
    tips11: '请输入排名区间从',
    tips12: '请输入排名区间止',
    tips13: '请排名区间从应小于排名区间止',
    tips14: '请输入考核等级',
    tips15: '请输入等级说明',
    tips16: '请选择是否合格',
    tips17: '请选择绩效策略',
    tips18: '请输入页签名称!',
    checkList1: '添加的考核结果为排名制，但并未启用考核结果-排名制，请设为启用！',
    checkList2: '添加的考核结果为分数制，但并未启用考核结果-分数制，请设为启用！',
    assessmentResults: '考核结果',
    qualified: '合格',
    failed: '不合格',
    upgrade: '升级',
    disuse: '淘汰',
    search1: '查询',
    reset: '重置',
    chooseMore: '多选',
    manualExecuteTip: '手动执行成功，请到绩效考核中查看',
    index: '序号',
    tip19: '请添加评估体系页签'
  },
  performanceAppraisal: {
    supBatLevel: '供应商按量/按批等级',
    search: {
      placeholder: '绩效考核单号',
      purchaseUnitNos: '采购中心',
      examineStartTime: '考核时间起',
      examineEndTime: '考核时间止',
      addbyName: '创建人',
      supplierNos: '供应商',
      statusList: '状态',
      examineSource: '来源',
      judgePerson: '评分人'
    },
    table: {
      processNo: '绩效考核单号',
      purchaseUnitName: '采购中心',
      assessSystemName: '评估体系',
      examineProcessPeriod: '考核周期',
      addByName: '创建人',
      examineYear: '考核年度',
      examineQuarter: '考核季度',
      examineMonth: '考核月份',
      examineSourceName: '来源',
      processStatusName: '状态'
    },
    pageTitle: {
      processAdd: '绩效考核新增',
      mark: '评分',
      viewMark: '查看评分',
      viewResult: '查看结果'
    },
    baseInfo: '基础信息',
    detailList: '绩效考核明细',
    formTitle: {
      baseInfo: '基础信息',
      processDetail: '绩效考核明细',
      evaluationSystem: '评估体系',
      processResult: ['考核结果-分数制', '考核结果-排名制'],
      useRule: '使用规则'
    },
    myLabel: ['考核月份', '考核季度', '考核半年', '考核年份'],
    import: '导入',
    add: '新增',
    processNo: '绩效考核单号',
    purchaseUnit: '采购中心',
    assessSystemName: '评估体系',
    assessSystemNo: '评估体系',
    examineProcessPeriod: '考核周期',
    workingPeriod: '考核周期',
    workingPeriodName: '运行周期',
    workingDateName: '运行时间',
    examineYear: '考核年度',
    examineQuarter: '考核季度',
    examineMonth: '考核月份',
    examineSourceName: '来源',
    judgePerson: '评分人',
    processStatusName: '状态',
    supplierName: '供应商',
    addby: '创建人',
    judgeScore: '评分',
    viewScore: '查看评分',
    revoke: '撤销',
    publish: '发布',
    lookResult: '查看结果',
    invalidate: '作废',
    importTip: '仅允许上传"xls"或"xlsx"格式文件',
    downloadName: ['无评估体系导入模板', '评分导入模板'],
    importWarn: '请先选择采购中心',
    submitWarn: '请导入绩效考核明细!',
    evaluationSystem: {
      quotaNo: '考核编码',
      quotaName: '指标名称',
      quotaTypeName: '取值类型',
      elementWeight: '权重',
      maxPoints: '分数上限',
      minPoints: '分数下限',
      examinePerson: '考核人员'
    },
    scoreResult: {
      markStart: '分数上限',
      markEnd: '分数下限',
      rankStart: '排名上限',
      rankEnd: '排名下限',
      examineLevel: '考核等级',
      levelRemarks: '等级说明',
      qualifiedStatus: '是否合格',
      performanceStrategy: '绩效策略'
    },
    evaluationDimension: '评估维度',
    supplierTable: {
      supplierNo: '供应商编码',
      supplierName: '供应商名称',
      classifyName: '供应商类别',
      supplierType: '供应商类别',
      supplierGroup: '供应商组',
      supplierStatus: '供应商状态',
      city: '城市',
      action: '操作'
    },
    rateInfo: '评分详情',
    itemType: '物料类别',
    score: '总分',
    level: '等级',
    revokeTip: '是否确认撤销？',
    invalidateTip: '是否确认作废？',
    deleteTip: '是否确认删除？',
    publishTip: '是否确认发布？',
    tips1: '至少保留一个供应商！',
    tips2: '待审核状态才可撤销',
    tips3: '已完成状态才可发布',
    tips4: '待评分与已完成状态才可作废',
    tips5: '创建人自己才能操作',
    delete: '删除'
  }
}
